import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=23bf9aab&"
import script from "./NumberInput.vue?vue&type=script&lang=js&"
export * from "./NumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23bf9aab')) {
      api.createRecord('23bf9aab', component.options)
    } else {
      api.reload('23bf9aab', component.options)
    }
    module.hot.accept("./NumberInput.vue?vue&type=template&id=23bf9aab&", function () {
      api.rerender('23bf9aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/NumberInput.vue"
export default component.exports